import React, { useEffect, useState } from "react";
import {
  callingCode,
  Nationality,
  scrollFunc,
  slashFormatter,
} from "../../../helpers/helper";
import DatePicker from "react-datepicker";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  getPassengersCount,
  increment,
  decrement,
  addInsuranceAsync,
  setPassengerCount,
  updateInsuranceAsync,
} from "../../../features/bookings/insuranceSlice";
import MainModal from "../../modals/MainModal";
import SuccessModal from "../../modals/SuccessModal";
import { useForm } from "../../../hooks/useForm";
import { useRef } from "react";

const Insurance = () => {
  // const [formErrors, setFormErrors] = useState({});
  // const [isSubmit, setIsSubmit] = useState(false);
  const scrollToIns = useRef(null);
  const [passengers, setPassengers] = useState([]);
  const [btnValue, setBtnValue] = useState("Proceed For Inquiry");
  const [editId, setEditId] = useState("");
  //
  const AgeRegex = /^[0-9\b]+$/;

  const customDyncVadlidate = (name, regex, e, obj, ind) => {
    if (passengers[ind].Age !== "") {
      if (!AgeRegex.test(passengers[ind].Age)) {
        obj[name] = "Please Enter a Valid Age!";
      } else {
        delete obj[name];
      }
    }

    return obj;
  };

  const customValidate = (errors, ind) => {
    if (passengers[ind]["Age"] !== "" && !AgeRegex.test(passengers[ind].Age)) {
      errors.Age = "Please Enter a Valid Age!";
    }
    // else if(parseInt(passengers[ind]["Age"]) < 0){
    //   errors.Age = "Please Enter a Valid Age!"
    // }
    //  &&
    return errors;
  };

  //
  const {
    state,
    setState,
    isSubmit,
    formErrors,
    handleInputChange,
    handleFormSubmit,
    checkErrors,
    handleInputDynamic,
    checkDyncErrors,
  } = useForm({
    val: {
      Title: "",
      FirstName: "",
      LastName: "",
      Email: "",
      Country: "",
      StartDate: "",
      EndDate: "",
      MobileNo: "",
      CountryCode: "",
      TravellingCountry: "",
    },
    dyncVals: {
      items: passengers,
      setItems: setPassengers,
      arrItems: ["Age", "Disease"],
    },
    inDyncValidate: customValidate,
    inDyncCheckValidate: customDyncVadlidate,
  });
  //
  const [modal, setModal] = useState("insurance");
  const [show, setShow] = useState(false);
  const [success, setSuccess] = useState(false);
  const [statusCode, setStatusCode] = useState("");
  const [status, setStatus] = useState("");
  const [msg, setMsg] = useState("");

  const passengersCount = useSelector(getPassengersCount);
  const insuranceStatus = useSelector(
    (state) => state.insurance.insuranceStatus,
    shallowEqual
  );
  const insuranceUpdateStatus = useSelector(
    (state) => state.insurance.insuranceUpdateStatus,
    shallowEqual
  );
  const { Authorization } = JSON.parse(sessionStorage.getItem("userData"));

  const dispatch = useDispatch();

  // scrollFunc();

  // Title: "Mr",
  // FirstName: "vivek",
  // LastName: "bakde",
  // Email: "v@gmail.com",
  // Country: "India",
  // StartDate: "2022-12-12",
  // EndDate: "2022-12-12",
  // MobileNo: "1234567890",
  // CountryCode: "AD",
  // TravellingCountry: "dubai",

  useEffect(() => {
    scrollToIns.current?.scrollIntoView({ behavior: "smooth" });
  }, []);

  // useEffect(()=>{

  // },[])

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      if (btnValue === "Proceed For Inquiry") {
        dispatch(addInsuranceAsync({ state, passengers, Authorization }));
      } else {
        dispatch(
          updateInsuranceAsync({ state, passengers, Authorization, editId })
        );
      }
    }
  }, [formErrors, isSubmit]);

  useEffect(() => {
    // if (passengersCount === 1) {
    //   let arr = [];
    //   for (let index = 0; index < passengersCount; index++) {
    //     arr.push({
    //       Age: "",
    //       AgeErr: "",
    //       Disease: "",
    //       DiseaseErr: "",
    //     });
    //   }
    //   setPassengers(arr);
    // } else
    setPassengers([
      {
        Age: "",
        Disease: "0",
      },
    ]);
    if (passengers.length < passengersCount) {
      setPassengers([...passengers, { Age: "", Disease: "0" }]);
    }
    //  else {
    //   let newArr = passengers.slice(0, -1);
    //   setPassengers(newArr);
    // }
  }, [passengersCount]);

  useEffect(() => {
    if (insuranceStatus !== "") {
      if (insuranceStatus === true) {
        setMsg("Your inquire has been generated we will get back to you soon.");
        // setStatus("Awesome!");
        setStatusCode(200);
      } else {
        setMsg("Something Went Wrong!");
        // setStatus("Failed!");
        setStatusCode(400);
      }
      setSuccess(true);
      //   setShow(false);
      //   setIsClicked(false);
    }
  }, [insuranceStatus]);

  useEffect(() => {
    if (insuranceUpdateStatus === true) {
      setState({
        Title: "",
        FirstName: "",
        LastName: "",
        Email: "",
        Country: "",
        StartDate: "",
        EndDate: "",
        MobileNo: "",
        CountryCode: "",
        TravellingCountry: "",
      });
      setPassengers([
        {
          Age: "",
          Disease: "0",
        },
      ]);
      scrollToIns.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [insuranceUpdateStatus]);

  const [startDate, setStartDate] = useState(
    new Date().setFullYear(new Date().getFullYear())
  );
  const endDateAll = new Date().setFullYear(new Date().getFullYear() + 1);

  const [endDate, setEndDate] = useState(
    new Date().setFullYear(new Date().getFullYear())
  );

  const handleStartChange = (e) => {
    let myDate = new Date(e.getTime() - e.getTimezoneOffset() * 60000)
      .toISOString()
      .split("T")[0];
    setStartDate(e.getTime() - e.getTimezoneOffset() * 60000);
    setState({ ...state, StartDate: myDate });
    delete formErrors["StartDate"];

    if (new Date(e) >= new Date(endDate)) {
      setEndDate(e.getTime() - e.getTimezoneOffset() * 60000);
      setState({ ...state, EndDate: myDate, StartDate: myDate });
      delete formErrors["StartDate"];
      delete formErrors["EndDate"];
    }
  };

  const handleEndChange = (e) => {
    let myDate = new Date(e.getTime() - e.getTimezoneOffset() * 60000)
      .toISOString()
      .split("T")[0];
    setEndDate(e.getTime() - e.getTimezoneOffset() * 60000);
    setState({ ...state, EndDate: myDate });
    delete formErrors["EndDate"];
  };

  const todayMinDate = new Date().setFullYear(new Date().getFullYear());

  const remove = (ind) => {
    let arr = passengers.filter((ele, i) => {
      return i !== ind;
    });

    setPassengers(arr);
  };

  const handleInsuranceModal = () => {
    // setSuccess(true);
    setShow(true);
    setModal("insurance");
  };

  const handleEditInsurance = (val) => {
    setState({
      Title: val.nameTitle,
      FirstName: val.firstName,
      LastName: val.lastName,
      Email: val.email,
      Country: val.user_country,
      StartDate: val.start_date,
      EndDate: val.end_date,
      MobileNo: val.mobile,
      CountryCode: val.country_code,
      TravellingCountry: val.travel_country,
    });
    setShow(false);
    setBtnValue("Update For Inquiry");
    let arr = [];
    val.insurance_booking_details.map((ele) => {
      arr.push({
        Age: ele.passanger_age,
        Disease: ele.pre_disease,
      });
    });
    setPassengers(arr);
    setEditId(val.id);
  };

  return (
    <>
      <section className="insurance-payment-main" ref={scrollToIns}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="title d-flex align-items-start justify-content-between">
                <h5 className="blue-b-24 mb-0">Add your details</h5>
                <button
                  className="cmn-btn insurance-btn"
                  onClick={handleInsuranceModal}
                >
                  My Insurance
                </button>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="review-booking-wrapper guest-details-wrapper my-insurance">
                <form action="" className="guest-detail-form insurance-form">
                  <div className="row">
                    <div className="col-lg-1">
                      <div className="form-group">
                        <label htmlFor="">Title</label>
                        <div className=" position-relative select-country-code">
                          <div className="select-arrow"></div>

                          <select
                            name="Title"
                            className="form-control"
                            onChange={handleInputChange}
                            onBlur={(e) => checkErrors(e)}
                            //   autoComplete="off"
                          >
                            <option value="">Title</option>
                            <option value="Mr.">Mr</option>
                            <option value="Ms.">Ms</option>
                            <option value="Mrs.">Mrs</option>
                          </select>
                          <span className="error">{formErrors?.Title}</span>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="">First Name</label>
                        <input
                          type="text"
                          placeholder="Enter First Name"
                          name="FirstName"
                          onChange={handleInputChange}
                          value={state.FirstName}
                          onBlur={(e) => checkErrors(e)}
                          autoComplete="off"
                        />

                        <span className="error">{formErrors?.FirstName}</span>
                      </div>
                    </div>

                    <div className="col-lg-4">
                      <div className="form-group">
                        <label htmlFor="">Last Name</label>
                        <input
                          type="text"
                          placeholder="Enter Last Name"
                          name="LastName"
                          onChange={handleInputChange}
                          value={state.LastName}
                          onBlur={(e) => checkErrors(e)}
                          autoComplete="off"
                        />

                        <span className="error">{formErrors?.LastName}</span>
                      </div>
                    </div>

                    <div className="col-lg-4">
                      <div className="form-group">
                        <label htmlFor="">Email</label>
                        <input
                          type="email"
                          placeholder="Enter Email"
                          name="Email"
                          onChange={handleInputChange}
                          value={state.Email}
                          onBlur={(e) => checkErrors(e)}
                          autoComplete="off"
                        />

                        <span className="error">{formErrors?.Email}</span>
                      </div>
                    </div>

                    <div className="col-lg-4">
                      <div className="first-name d-flex">
                        <div className="form-group">
                          <label htmlFor="">Your Country</label>
                          <div className=" position-relative select-country-code">
                            <div className="select-arrow"></div>

                            <select
                              name="Country"
                              onChange={handleInputChange}
                              className="form-control"
                              value={state.Country}
                              onBlur={(e) => checkErrors(e)}
                            >
                              <option value="">Select Country</option>
                              {Nationality.map((ele, ind) => (
                                <option
                                  key={ind}
                                  value={ele.value}
                                  defaultValue={state.Country}
                                >
                                  {ele.label}
                                </option>
                              ))}
                            </select>
                            <span className="error">{formErrors?.Country}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/*  */}

                    <div className="col-lg-4">
                      <div className="first-name d-flex">
                        <div className="form-group">
                          <label htmlFor="">Travelling Country</label>
                          <div className=" position-relative select-country-code">
                            <div className="select-arrow"></div>

                            <select
                              name="TravellingCountry"
                              onChange={handleInputChange}
                              className="form-control"
                              onBlur={(e) => checkErrors(e)}
                              value={state.TravellingCountry}
                            >
                              <option value="">Select Country</option>
                              {Nationality.map((ele, ind) => (
                                <option
                                  key={ind}
                                  value={ele.value}
                                  defaultValue={state.TravellingCountry}
                                >
                                  {ele.label}
                                </option>
                              ))}
                            </select>
                            <span className="error">
                              {formErrors?.TravellingCountry}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-4 position-relative">
                      <label htmlFor="">Start Date</label>
                      <DatePicker
                        onChange={handleStartChange}
                        peekNextMonth
                        showMonthDropdown
                        selected={Date.parse(state.StartDate)}
                        showYearDropdown
                        dropdownMode="select"
                        minDate={todayMinDate}
                        maxDate={endDateAll}
                        dateFormat="yyyy/MM/dd"
                        placeholderText="Start Date"
                        value={
                          state.StartDate !== ""
                            ? slashFormatter(state.StartDate)
                            : ""
                        }
                        name="StartDate"
                        // onFocus={(e) => setErrors(e)}
                        onBlur={(e) => checkErrors(e)}
                        className="form-control"
                        style={{ Zindex: "100" }}
                        autoComplete="off"
                      />
                      <i
                        className="fas fa-calendar-week position-absolute"
                        style={{
                          top: "56px",
                          right: "28px",
                          color: "#959597",
                        }}
                      ></i>
                      <span className="error">{formErrors?.StartDate}</span>
                    </div>

                    <div className="col-lg-4 position-relative">
                      <label htmlFor="">End Date</label>
                      <DatePicker
                        onChange={handleEndChange}
                        peekNextMonth
                        showMonthDropdown
                        // selected={endDate}
                        selected={Date.parse(state.EndDate)}
                        showYearDropdown
                        dropdownMode="select"
                        minDate={startDate}
                        maxDate={endDateAll}
                        dateFormat="yyyy/MM/dd"
                        name="EndDate"
                        placeholderText="End Date"
                        value={
                          state.EndDate !== ""
                            ? slashFormatter(state.EndDate)
                            : ""
                        }
                        // onFocus={(e) => setErrors(e)}
                        className="form-control"
                        style={{ Zindex: "100" }}
                        autoComplete="off"
                        onBlur={(e) => checkErrors(e)}
                      />
                      <i
                        className="fas fa-calendar-week position-absolute"
                        style={{
                          top: "56px",
                          right: "28px",
                          color: "#959597",
                        }}
                      ></i>
                      <span className="error">{formErrors?.EndDate}</span>
                    </div>
                    <div className="col-lg-4">
                      <div className="mobile-number">
                        <div className="form-group">
                          <label for="">Mobile Number </label>
                          <div>
                            <div className="position-relative select-country-code">
                              <div className="select-arrow"></div>
                              <select
                                name="CountryCode"
                                onChange={handleInputChange}
                                className="form-control"
                                onBlur={(e) => checkErrors(e)}
                                value={state.CountryCode}
                              >
                                <option value=""> Code</option>
                                {callingCode.map((ele, ind) => (
                                  <option
                                    key={ind}
                                    value={ele.label.split(" ")[0]}
                                    defaultValue={state.CountryCode}
                                  >
                                    {ele.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <input
                              type="text"
                              placeholder="Enter Mobile Number"
                              name="MobileNo"
                              value={state.MobileNo}
                              onChange={handleInputChange}
                              autoComplete="off"
                              onBlur={(e) => checkErrors(e)}
                            />
                          </div>
                          <span className="error">
                            {formErrors?.CountryCode}
                          </span>
                          <span className="error">{formErrors?.MobileNo}</span>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-12">
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          passengersCount < 8 && dispatch(increment());
                        }}
                        className="cmn-btn insurance-add remove-btn mt-0"
                      >
                        Add More
                      </button>
                    </div>
                  </div>

                  {passengers.map((ele, index) => (
                    <div className="row" key={index}>
                      <div className="row align-items-end">
                        <div className="col-lg-4 ">
                          <div className="form-group mb-lg-0 mb-md-0">
                            <label htmlFor="">Age</label>
                            <input
                              type="text"
                              name={"Age[]"}
                              onChange={(e) => handleInputDynamic(index, e)}
                              value={ele.Age}
                              onBlur={(e) => checkDyncErrors(index, e)}
                              autoComplete="off"
                              placeholder="Enter Age"
                            />
                            <span className="error">
                              {formErrors[index]?.Age}
                            </span>
                          </div>
                        </div>

                        <div className="col-lg-4">
                          <div className="form-group mb-lg-0 mb-md-0">
                            <label htmlFor="">Pre - Disease</label>
                            <div className=" position-relative select-country-code">
                              <div className="select-arrow"></div>

                              <select
                                className="w-100 form-control"
                                value={ele.Disease}
                                onChange={(e) => handleInputDynamic(index, e)}
                                name={"Disease[]"}
                                onBlur={(e) => checkDyncErrors(index, e)}
                              >
                                <option value={"0"} defaultValue={ele.Disease}>
                                  No
                                </option>
                                <option value={"1"}>yes</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-4 ">
                          {index > 0 && (
                            <button
                              className="cmn-btn remove-btn mt-0"
                              type="button"
                              onClick={() => {
                                remove(index);
                              }}
                            >
                              Remove
                            </button>
                          )}
                        </div>
                        {/*  */}
                      </div>
                    </div>
                  ))}
                  <div className="col-lg-12">
                    <button
                      type="submit"
                      className="cmn-btn reserve-btn d-block w-100"
                      onClick={handleFormSubmit}
                    >
                      {btnValue}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {success ? (
          <SuccessModal
            setShow={setShow}
            show={success}
            msg={msg}
            status={status}
            statusCode={statusCode}
          />
        ) : null}

        {show ? (
          <MainModal
            modal={modal}
            setShow={setShow}
            show={show}
            setModal={setModal}
            handleEditInsurance={handleEditInsurance}
          />
        ) : null}
      </section>
    </>
  );
};

export default Insurance;
